module.exports = "/images/gu.svg?0cde6655ed01c04dfb162e7d039a50f7";